export default class LocalStorageFeature<Type> {
  private readonly storageName!: string

  constructor (storageName: string) {
    this.storageName = storageName
  }

  /**
   * возвращает данные из хранилища
   *
   * @returns {Promise<* | boolean>} result
   */
  public getData (): Promise<Type | boolean> {
    try {
      const lastActivity: string | null = localStorage.getItem(this.storageName)
      if (lastActivity) {
        return Promise.resolve(JSON.parse(lastActivity))
      }
    } catch (err) {
      return Promise.reject(err)
    }

    return Promise.resolve(false)
  }

  /**
   * сохраняет указанные данные в хранилице
   *
   * @param {*} data - что нужно сохранить
   * @returns {Promise<boolean>} result
   */
  public saveData (data: Type): Promise<boolean> {
    try {
      localStorage.setItem(this.storageName, JSON.stringify(data))
      return Promise.resolve(true)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * устанавливает глобальный слушатель
   *
   * @param {string} eventName - название события
   */
  public setEventListener (eventName: string) {
    window.$nuxt.$eventBus.$on(eventName, e => this.saveData(e))
  }
}
